import React from "react";
import { Modal, Button } from "react-bootstrap";
import Loader from "rsuite/Loader";
import { FilterCloseIcon } from "../../Icons/icons.component";

export const ConfirmModal = function ({
  show,
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  confirmText,
  modalTitle = "Confirmation",
  disableSubmit = false,
  isLoading
}) {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      className="customModalWrap"
    >
      <Modal.Header>
        <Modal.Title>{modalTitle}</Modal.Title>
        <button className="btnModalClose" onClick={() => onCancel(false)}>
          <FilterCloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body>{confirmText || "Proceed ?"}</Modal.Body>
      <Modal.Footer>
        <Button
          disabled={disableSubmit}
          variant="primary"
          onClick={onConfirm}
          className="btn btnBlue"
        >
          {confirmButtonText}
        </Button>
        {isLoading && <Loader />}
      </Modal.Footer>
    </Modal>
  );
};

ConfirmModal.defaultProps = {
  show: false,
  onConfirm: () => { },
  onCancel: () => { },
  confirmButtonText: "Ok",
  confirmText: "Proceed ?",
  modalTitle: "Confirmation",
  cancelButtonText: "Cancel",
  isLoading: false
};
